import Contract from '@/components/Contract/Contract.vue';
import ContractTemplate from '@/components/Contract/ContractTemplate.vue';
import ContractDetail from '@/components/Contract/ContractDetail.vue';

export default [
    {
        name: 'contract',
        path: '/contract',
        component: Contract,
        meta: { roles: ['role_administrator'] },
    },
    {
        name: 'contractTemplate',
        path: '/contract-template',
        component: ContractTemplate,
        meta: { roles: ['role_administrator'] },
    },
    {
        name: 'contractTemplate',
        path: '/contract/:id',
        component: ContractDetail,
        meta: { roles: ['role_administrator'] },
    },
];
